import { Component } from 'vue-property-decorator'
import Template from '@/components/BaseCurd/template'
import '@/components/tableStyle/index.less'
import { CustomerUserApplicationServiceProxy, CustomerOauthServiceProxy } from '@/service-proxies/app-v2/masterlink-cps-client.service-proxies'
import { cloneDeep } from 'lodash'
import dayjs from 'dayjs'
import './index.less'

const api = new CustomerUserApplicationServiceProxy()
const api2 = new CustomerOauthServiceProxy()

@Component
export default class BindApply extends Template {
  name = '绑定申请'

  options = {
    retrieve: api.page.bind(api),
    search: null,
    create: null,
    update: null,
    delete: null
  }
  acl = {
    create: 'page_apply_list_bind_approve',
    delete: 'page_apply_list_bind_refuse'
  }

  params = {
    statusList: [1, 2, 3]
  }

  scroll = {}
  subLoading = false
  historyList = [] // 历史绑定记录

  get lang() {
    return {
      create: this.$t('page_apply_list_bind_approve'),
      placeholder: this.$t('keyword'),
      search: this.$t('search'),
      delete: this.$t('page_apply_list_bind_refuse')
    }
  }

  get statusList() {
    return [
      { label: this.$t('page_control_handle'), value: 1, color: 'orange' }, // 待处理
      { label: this.$t('page_bind_apply_approved'), value: 2, color: 'green' }, // 已通过
      { label: this.$t('page_bind_apply_refused'), value: 3, color: 'red' } // 已拒绝
    ]
  }

  created() {
    let table: any = document.getElementsByClassName('temp-table-con')
    let height = 300
    if (table) {
      height = table.clientHeight - 40
    }
    this.scroll = { y: height }
  }

  render() {
    return this.customRender()
  }

  get hisColumns() {
    return [
      { // 提交时间
        title: this.$t('page_extranet_Submit_time'), dataIndex: 'createTime', width: 150,
        customRender: (time) => {
          return time ? dayjs(time).format('YYYY-MM-DD HH:mm:ss') : '-'
        }
      },
      { title: this.$t('page_suolide_customer_name'), dataIndex: 'customerName', width: 120 }, // 客户名称
      { title: this.$t('page_ops_customer_province'), dataIndex: 'provinceName', width: 120 }, // 省份
      { title: this.$t('page_ops_customer_detailed_address'), dataIndex: 'address', width: 250 } // 详细地址
    ]
  }

  get columns() {
    return [
      {
        title: this.$t('page_batch_management_action'),
        key: 'action',
        width: 100,
        customRender: (row, record) => {
          return record.status === 1 ? (
            <div>
              <a
                disabled={!this.getAcl(this.acl.create)}
                type="link"
                onClick={(e) => {
                  e.stopPropagation()
                  this.handlePass(record)
                }}
              >
                {this.lang.create}
              </a>
              <a-divider type="vertical"/>
              <a-popconfirm
                disabled={!this.getAcl(this.acl.delete)}
                title={this.$t('page_bind_apply_sure_to_refuse')}
                onConfirm={() => this.handleRefuse(record)}
                okText={this.$t('yes')}
                cancelText={this.$t('no')}
              >
                <a
                  type="link"
                  disabled={!this.getAcl(this.acl.delete)}
                  onClick={(e) => e.stopPropagation()}
                  class="del-color"
                >
                  {this.lang.delete}
                </a>
              </a-popconfirm>
            </div>
          ): '-'
        }
      },
      { title: this.$t('page_ops_work_record_document_number'), dataIndex: 'code', width: 130 },// 单据号
      { title: this.$t('page_ops_work_record_contact_person'), dataIndex: 'userName' }, // 上报人
      { title: this.$t('page_ops_work_record_contact_information'), dataIndex: 'phone', width: 120 }, // 联系方式
      {
        title: this.$t('page_bind_apply_history_bind_times'), dataIndex: 'bindNum', // 历史绑定次数
        customRender: (text, record) => (
          this.renderHistoryTable(text, record)
        )
      },
      {
        title: this.$t('page_extranet_Submit_time'), dataIndex: 'createTime', width: 150,
        customRender: (time) => {
          return time ? dayjs(time).format('YYYY-MM-DD HH:mm:ss') : '-'
        }
      },
      { title: this.$t('page_suolide_customer_name'), dataIndex: 'customerName', width: 180 },
      { title: this.$t('page_ops_customer_province'), dataIndex: 'provinceName' },
      { title: this.$t('page_ops_customer_detailed_address'), dataIndex: 'address', width: 250 },
      {
        title: this.$t('page_ops_work_record_record_status'), dataIndex: 'status',
        customRender: (val) => {
          const status = this.statusList.find(item => item.value === Number(val))
          return status ? (
            <a-tag color={status.color}>
              {status.label}
            </a-tag>
          ):null
        }
      }
    ]
  }

  getCheckboxProps(record) {
    return ({
      style: {
        display: record.id ? 'block' : 'none'
      },
      props: {
        disabled: record.status && record.status > 1
      }
    })
  }


  async getData(
    current = this.filters.current,
    size = this.filters.size,
    keyWords = this.keywords,
    reload: any = false
  ) {
    this.loading = true
    if (reload) current = 1
    const fetchFn = this.options.retrieve.bind(this)
    const { records, total: t, size: s, current: c } = await fetchFn(
      current,
      {
        keyWord: keyWords,
        statusList: this.params.statusList
      },
      size
    )
    this.loading = false


    /*let dataLength = records.length
    let copy = cloneDeep(records)
    let needPush = 0
    if (dataLength < 30) {
      needPush = 30 - dataLength
      for (var k = 0; k < needPush; k++) {
        let obj = {
          // id: 'none'
        }
        copy.push(obj)
      }*/
      // todo
      this.dataSource = cloneDeep(records)

      this.filters = {
        total: Number(t),
        size: Number(s),
        current: Number(c)
      }
    
  }

  inputStatus(value) {
    const newTags = [...this.params.statusList]
    const status = this.params.statusList.find((res) => res == value)
    if (!status) {
      this.params.statusList.push(value)
    } else {
      this.params.statusList = newTags.filter((res) => res != value)
    }
    this.filters.size = 30
    this.filters.current = 1
    this.getData()
  }

  // 查看历史绑定次数
  renderHistoryTable(val, record) {
    return val ? <a-popover trigger="click" placement="bottom"
                            forceRender={true}
                      scopedSlots={{
                        content: props => <ml-table
                          loading={this.subLoading}
                          columns={this.hisColumns}
                          dataSource={this.historyList}
                          size="small"
                          rowKey="createTime"
                          scroll={{ y: 500 }}
                          pagination={false}
                          style="width: 680px"
                        />
                      }}
    >
      <a-button type="link" onclick={()=>this.getHistoryTimes(record)}>
        {val}
      </a-button>
    </a-popover> : '0'
  }

  async getHistoryTimes(record) {
    this.historyList = []
    this.subLoading = true
    try {
      const res = await api2.getUserBindRecordList({
        createTime: record.createTime,
        openid: record.openid
      } as any)
      this.historyList = res
    } finally {
      this.subLoading = false
    }

  }

  // 通过
  async handlePass(row?) {
    const ids = row && row.id ? [row.id] : this.selectedRowKeys
    await api.process({ids: ids, status: 2} as any)
    this.$message.success(this.$t('page_resource_pool_success'))
    this.getData()
  }

  // 拒绝
  async handleRefuse(row?) {
    const ids = row && row.id ? [row.id] : this.selectedRowKeys
    await api.process({ids: ids, status: 3} as any)
    this.$message.success(this.$t('page_resource_pool_success'))
    this.getData()
  }

  renderHeader(slot = null) {

    const passBtn = (
      <a-button
        v-acl={this.acl.create}
        type="primary"
        style={{ marginRight: '8px' }}
        onClick={this.handlePass}
        disabled={!this.selectedIds.length}
      >
        {this.lang.create}
      </a-button>
    )

    const refuseBtn = (
      <a-popconfirm
        title={this.$t('page_bind_apply_sure_to_refuse')}
        onConfirm={this.handleRefuse}
        okText={this.$t('yes')}
        cancelText={this.$t('no')}
        disabled={!this.selectedIds.length}
      >
        <a-button
          v-acl={this.acl.delete}
          type="danger"
          disabled={this.selectedIds.length < 1}
        >
          {this.lang.delete}
        </a-button>
      </a-popconfirm>
    )

    const filter = (
      <div class="flex status-choose mg-r8">
        <div class="flex status-choose state-filter">
          <div class="label">{this.$t('page_ops_work_record_filter') + '：'}</div>

          {this.statusList.map(status => (
            <div key={status.value}>
              {this.params.statusList.includes(status.value) ? <a-tag
                  color={status.color}
                  onClick={() => this.inputStatus(status.value)}
                >
                  {status.label}
                </a-tag> :
                <a-tag
                  style="background: #fff; border-style: dashed"
                  onClick={() => this.inputStatus(status.value)}
                >
                  {status.label}
                </a-tag>}
            </div>))}

        </div>
      </div>
    )

    return (
      <div
        slot="action"
        style={{
          display: 'flex',
          justifyContent: 'space-between'
        }}
      >
        <div>
          {passBtn}
          {refuseBtn}
        </div>
        {this.showSearch ? (<div style="display:flex;align-items:center">
          {filter}
          <a-input-search
            placeholder={this.lang.placeholder}
            onSearch={this.onSearch}
            enterButton={this.lang.search}
            allowClear={true}
          ></a-input-search>
        </div>) : null}
      </div>
    )
  }

}





